/**
 * Hide Loox "Powered by Loox" under the V2 carousel.
 * .loox-branding lives inside a cross-origin iframe (loox.io), so parent CSS
 * cannot target it. After Loox posts its resize height, clip the bottom strip.
 */
(function () {
  var BRANDING_STRIP_PX = 40;
  var SELECTOR = '.loox-v2-carousel-container.loox-widget';

  function hideInDocument(doc) {
    if (!doc) return false;
    var nodes = doc.querySelectorAll('.loox-branding');
    if (!nodes.length) return false;
    nodes.forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
    return true;
  }

  function clipContainer(iframe, fullHeight) {
    var container = iframe && iframe.closest(SELECTOR);
    if (!container || !fullHeight || fullHeight < 120) return;

    var clipped = Math.max(fullHeight - BRANDING_STRIP_PX, 0);
    var clippedPx = clipped + 'px';

    container.style.overflow = 'hidden';
    container.style.height = clippedPx;
    iframe.style.height = clippedPx;
    iframe.height = String(clipped);
  }

  function tryHideInsideIframe(iframe) {
    try {
      return hideInDocument(iframe.contentDocument);
    } catch (e) {
      return false;
    }
  }

  function onCarouselResize(frameId, height) {
    var iframe = document.getElementById(frameId);
    if (!iframe || !iframe.closest(SELECTOR)) return;

    requestAnimationFrame(function () {
      if (tryHideInsideIframe(iframe)) return;
      clipContainer(iframe, parseFloat(height, 10));
    });
  }

  window.addEventListener('message', function (event) {
    var data = event.data;
    if (typeof data === 'string' && data.indexOf('{') === 0) {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }
    }
    if (!data || data.type !== 'resize' || !data.frame || data.to === 'visualViewport') return;
    onCarouselResize(data.frame, data.height);
  });

  function bindExisting() {
    document.querySelectorAll(SELECTOR).forEach(function (container) {
      hideInDocument(container);
      var iframe = container.querySelector('iframe');
      if (!iframe) return;
      iframe.addEventListener('load', function () {
        if (tryHideInsideIframe(iframe)) return;
        var height = parseFloat(iframe.style.height || iframe.height, 10);
        if (height) clipContainer(iframe, height);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindExisting);
  } else {
    bindExisting();
  }
})();
